import Button from "@material-ui/core/Button";
import Drawer from "@material-ui/core/Drawer";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import withStyles from "@material-ui/core/styles/withStyles";
import { instance } from "Actions/AxiosInstance";
import bankillustration from "Assets/Svg/bank-illustration.svg";
import IciciIcon from "Assets/Svg/ICICI_Bank_Logo.svg";
import OverviewCompleted from "Assets/Svg/overview-completed.svg";
import DynamicForm from "Component/DynamicForm";
import { checkboxinputconverter } from "Component/DynamicForm/Fields/CheckBox";
import DrawerHeader from "Component/Headers/drawerHeader";
import PageHeader from "Component/Headers/pageHeader";
import * as FileSaver from "file-saver";
import get from "lodash/get";
import moment from "moment";
import { withSnackbar } from "notistack";
import React from "react";
import { connect } from "react-redux";
import * as XLSX from "xlsx";
import { convertDateForBackend } from "Utils";

const styles = () => ({
  drawerPaper: {
    width: 356,
  },
});

export const ExportArrearsXLSX = (props = {}) => {
  const { rows = [] } = props;
  const filename = `banksheet_${moment().format(
    "MMMM Do YYYY-h:mm:ss-a",
  )}.xlsx`;
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const headers = [
    "employeecode",
    "employeename",
    "totalnetamount",
    "paymentmethod",
    "accountnumber",
    "branchname",
    "bankname",
    "locationname",
    "ifsccode",
    "hold",
  ];
  const ws = XLSX.utils.json_to_sheet([...rows], {
    header: headers,
    skipHeader: true,
  });
  /* hide employeeid column */
  // ws["!cols"] = [];
  // ws["!cols"][7] = { hidden: true };
  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, filename);
};

export const ExportArrearsXLSX1 = (props = {}) => {
  const { rows = [] } = props;
  const filename = `banksheet_${moment().format(
    "MMMM Do YYYY-h:mm:ss-a",
  )}.xlsx`;
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const headers = [
    "paymenttypecode",
    "paymentmode",
    "debitaccnumber",
    "employeename",
    "accountnumber",
    "ifsccode",
    "totalnetamount",
    "debitnarr",
    "creditnarr",
    "mobile",
    "emailid",
    "remark",
    "paymentdate",
    "refno",
    "addlinfo1",
    "addlinfo2",
    "addlinfo3",
    "addlinfo4",
    "addlinfo5"
  ];
  const ws = XLSX.utils.json_to_sheet([...rows], {
    header: headers,
    skipHeader: true,
  });
  /* hide employeeid column */
  // ws["!cols"] = [];
  // ws["!cols"][7] = { hidden: true };
  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, filename);
};

class PayrollCompleted extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fromdate: "",
      generated: false,
      banksheetdrawer: false,
      open: false,
      employeelist: [],
    };
  }

  componentDidMount() {}

  analysedData() {}

  generateSalarySlip = () => {
    const { postdataforemplist } = this.props;
    if (this.state.employeelist && this.state.employeelist.length == 0) {
      instance
        .post("payroll/employeelist", postdataforemplist)
        .then((resp) => {
          this.setState({
            employeelist: get(resp, "data.result[0].employeelist", []),
            open: true,
          });
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    } else {
      this.setState({
        open: true,
      });
    }
  };

  getPayslip = () => {
    const { salarycycle, payrollcycle } = this.props;
    const { employeelist } = this.state;
    const postdata = {
      payrollcycledurationid: get(payrollcycle, "payrollcycledurationid", 12),
      salarycycleid: get(salarycycle, "salarycycleid", 12),
      salarycyclesplitid: get(salarycycle, "displayvalue", 12),
      employeeids: employeelist
        .filter((x) => x.isexpanded)
        .map((x) => x.employeeid),
    };

    postdata.employeeids && postdata.employeeids.length > 0
      ? instance
          .post("payroll/generatesalaryslip", postdata)
          .then(() => {
            this.props.enqueueSnackbar("Salary slip generated successfully", {
              variant: "success",
            });
            this.setState({
              open: false,
            });
          })
          .catch((error) => {
            this.props.enqueueSnackbar(
              error.response
                ? error.response.data.error.message
                : error.message,
              { variant: "error" },
            );
          })
      : this.props.enqueueSnackbar("Please select atleast one employee", {
          variant: "error",
        });
  };

  download = () => {
    const { postdataforemplist } = this.props;
    const { payrollcycle, salarycycle } = this.props;
    instance
      .post("payroll/employeelist", postdataforemplist)
      .then((resp) => {
        instance
          .post("payroll/getemployeebanksheetdetails", {
            payrollcycledurationid: get(
              payrollcycle,
              "payrollcycledurationid",
              12,
            ),
            salarycyclesplitid: get(salarycycle, "displayvalue", 12),
            salarycycleid: get(salarycycle, "salarycycleid", 12),
            payrollyear: get(salarycycle, "payrollyear", 12),
            payrollmonthid: get(salarycycle, "payrollmonthid", 12),
            employeeids: get(resp, "data.result[0].employeelist", []).map(
              (x) => x.employeeid,
            ),
          })
          .then((resp1) => {
            console.log("resp: ", resp1);
            const headerobj = {
              employeecode: "Employee code",
              employeename: "Employee name",
              totalnetamount: "Total net amount",
              paymentmethod: "Cash",
              accountnumber: "Account number",
              branchname: "Branch name",
              bankname: "Bank name",
              locationname: "Location name",
              ifsccode: "IFSC code",
              hold: "Hold",
            };

            const allrows = [
              headerobj,
              ...resp1.data.result.map((emp) => ({
                employeecode: emp.employeecode,
                employeename: emp.employeename,
                totalnetamount: emp.totalnetamount,
                paymentmethod: emp.paymentmethod,
                accountnumber: emp.accountnumber,
                branchname: emp.branchname,
                bankname: emp.bankname,
                locationname: emp.locationname,
                ifsccode: emp.ifsccode,
                hold: emp.hold,
              })),
            ];
            ExportArrearsXLSX({
              rows: allrows,
            });

            const data = {
              generationtypeid: 1,
              reportcatagoryid: 4,
              reporttypeid: 304,
              reportfor: {"reportforlog":[{"genaratefortypeid":1,"genarateforids":null,"locationids":null,"stageids":"1,2,3,4,5,6,7,8","reviewformids":null,"employmenttypeids":"1,2,3,4,5,6,7,8,9"}]},
              fromdate: convertDateForBackend(get(salarycycle, "cyclefrom", 12)),
              todate: convertDateForBackend(get(salarycycle, "cycleto", 12)),
            };
        
            instance.post("/reportrobo/reportrobolog", data);

          })
          .catch((error) => {
            this.props.enqueueSnackbar(
              error.response
                ? error.response.data.error.message
                : error.message,
              { variant: "error" },
            );
          });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  };

  downloadIcci = () => {
    const { postdataforemplist } = this.props;
    const { payrollcycle, salarycycle } = this.props;
    instance
      .post("payroll/employeelist", postdataforemplist)
      .then((resp) => {
        instance
          .post("payroll/getemployeebanksheetdetails", {
            payrollcycledurationid: get(
              payrollcycle,
              "payrollcycledurationid",
              12,
            ),
            salarycyclesplitid: get(salarycycle, "displayvalue", 12),
            salarycycleid: get(salarycycle, "salarycycleid", 12),
            payrollyear: get(salarycycle, "payrollyear", 12),
            payrollmonthid: get(salarycycle, "payrollmonthid", 12),
            employeeids: get(resp, "data.result[0].employeelist", []).map(
              (x) => x.employeeid,
            ),
          })
          .then((resp1) => {
            console.log("resp: ", resp1);
            if (resp1.data.result && resp1.data.result.length > 0) {
              const headerobj = {
                paymenttypecode: "PYMT_PROD_TYPE_CODE",
                paymentmode: "PYMT_MODE",
                debitaccnumber: "DEBIT_ACC_NO",
                employeename: "BNF_NAME",
                accountnumber: "BENE_ACC_NO",
                ifsccode: "BENE_IFSC",
                totalnetamount: "AMOUNT",
                debitnarr: "DEBIT_NARR",
                creditnarr: "CREDIT_NARR",
                mobile: "MOBILE_NUM",
                emailid: "EMAIL_ID",
                remark: "REMARK",
                paymentdate: "PYMT_DATE",
                refno: "REF_NO",
                addlinfo1: "ADDL_INFO1",
                addlinfo2: "ADDL_INFO2",
                addlinfo3: "ADDL_INFO3",
                addlinfo4: "ADDL_INFO4",
                addlinfo5: "ADDL_INFO5"
              };

              const allrows = [
                headerobj,
                ...resp1.data.result.flatMap(details => 
                  details.arrEmpDetails.map(emp => ({
                    paymenttypecode: details.paymenttypecode,
                    paymentmode: details.paymentmode,
                    debitaccnumber: details.debitaccnumber,
                    employeename: emp.employeename,
                    accountnumber: emp.accountnumber,
                    ifsccode: emp.ifsccode,
                    totalnetamount: emp.totalnetamount,
                    debitnarr: details.debitnarr,
                    creditnarr: details.creditnarr,
                    mobile: emp.mobile,
                    emailid: emp.emailid,
                    remark: details.remark,
                    paymentdate: details.paymentdate,
                    refno: details.refno,
                    addlinfo1: details.addlinfo1,
                    addlinfo2: details.addlinfo2,
                    addlinfo3: details.addlinfo3,
                    addlinfo4: details.addlinfo4,
                    addlinfo5: details.addlinfo5
                  }))
                ),
              ];
              ExportArrearsXLSX1({
                rows: allrows,
                name: salarycycle && salarycycle.displayname,
              });

              const data = {
                generationtypeid: 1,
                reportcatagoryid: 4,
                reporttypeid: 304,
                reportfor: {"reportforlog":[{"genaratefortypeid":1,"genarateforids":null,"locationids":null,"stageids":"1,2,3,4,5,6,7,8","reviewformids":null,"employmenttypeids":"1,2,3,4,5,6,7,8,9"}]},
                fromdate: convertDateForBackend(get(salarycycle, "cyclefrom", 12)),
                todate: convertDateForBackend(get(salarycycle, "cycleto", 12)),
              };
          
              instance.post("/reportrobo/reportrobolog", data);

            } else {
              this.props.enqueueSnackbar("No record found", {
                variant: "error",
              });
            }
          });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  };

  render() {
    const { employeelist } = this.state;

    return (
      <Grid container spacing={3}>
        <Grid item xs={12} md={7} sm={12} className="position-rel">
          <div style={{ position: "absolute", top: -44 }}>
            <div>
              <PageHeader header="Completed!" />
              <p className="normal-dark-secondary margin-top-16">
                Payroll data has been successfully generated! You can download
                the generated bank sheet below customized for your selected
                bank. 🕺
              </p>
              <Button
                className="btn btn-primary-md-blue margin-top-16"
                variant="contained"
                onClick={() =>
                  this.setState({
                    banksheetdrawer: true,
                  })
                }
                // onClick={onNext}
              >
                Bank sheet
              </Button>
            </div>
          </div>
        </Grid>
        <Grid
          item
          xs={12}
          md={5}
          sm={12}
          className="display-flex"
          style={{ flexDirection: "column", alignItems: "flex-end" }}
        >
          <div className="clear-float" style={{ marginTop: 70 }}>
            <img src={OverviewCompleted}></img>
          </div>
        </Grid>
        <div className="width100">
          <div>
            <div className="floatleft" style={{ marginLeft: 172 }}>
              <div
                className="width100"
                style={{
                  position: "fixed",
                  left: 0,
                  background: "white",
                  bottom: 0,
                  padding: 10,
                  borderTop: "1px solid #d4d4d4",
                  zIndex: 1,
                }}
              >
                <div>
                  <div className="floatleft" style={{ marginLeft: 172 }}>
                    <Button
                      className="btn btn-secondary-md-blue margin-right-16"
                      variant="contained"
                      onClick={this.generateSalarySlip}
                    >
                      Generate salary slips
                    </Button>
                  </div>
                  <div className="floatright" style={{ marginRight: 72 }}>
                    <Button
                      className="btn btn-primary-md-blue"
                      variant="contained"
                      onClick={() =>
                        window.open(
                          "../../app/payroll/startpayroll/payroll_dashboard",
                          "_self",
                        )
                      }
                    >
                      Go to dashboard
                    </Button>
                  </div>
                  <div className="clearfloat"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Drawer
          anchor="right"
          open={this.state.banksheetdrawer}
          onClose={() => this.setState({ banksheetdrawer: false })}
          style={{ padding: 40 }}
          classes={{
            paper: "planner-drawer padding15 width30",
          }}
        >
          <div className="position-rel" style={{ height: "100vh" }}>
            <DrawerHeader
              header="Download Bank Sheet"
              isbackarrow={false}
              closeDrawer={() => this.setState({ banksheetdrawer: false })}
            />
            <div style={{}}>
              <Paper className="padding16 margin-bottom-16 rounded-rectangle-paper">
                <div className="floatleft">
                  <img src={bankillustration} className="floatleft" />
                  <p
                    className="large-text-dark paddin-left-16 margin-left-24 padding-top-4"
                    style={{ paddingLeft: 16 }}
                  >
                    Default bank sheet
                  </p>
                </div>
                <div className="clear-float"></div>
                <p className="small-dark-secondary margin-top-16">
                  Get a generic bank sheet that works for most banks by clicking
                  on the download button below.
                </p>
                <Button
                  className="btn btn-primary-md-blue margin-top-16 "
                  variant="contained"
                  onClick={this.download}
                  style={{ fontSize: 14 }}
                >
                  Download
                </Button>
              </Paper>
              <Paper className="padding16 margin-bottom-16 rounded-rectangle-paper">
                <img
                  src={IciciIcon}
                  // className="height100 width100"
                />
                <p
                  className="
small-dark-secondary margin-top-16"
                >
                  Download and use this bank sheet if your company's salary is
                  processed via ICICI Bank.
                </p>
                <Button
                  className="btn btn-primary-md-blue margin-top-16 "
                  variant="contained"
                  onClick={this.downloadIcci}
                  // startIcon={<DeleteIcon />}
                  style={{ fontSize: 14 }}
                >
                  Download
                </Button>
              </Paper>
            </div>
          </div>
        </Drawer>

        <Drawer
          anchor="right"
          open={this.state.open}
          onClose={() => this.setState({ open: false })}
          style={{ padding: 40 }}
          classes={{
            paper: "planner-drawer padding15 width25",
          }}
        >
          <DrawerHeader
            header={"Generate payslip"}
            isbackarrow={false}
            closeDrawer={() => this.setState({ open: false })}
          />
          {
            <p className="normal-dark-secondary margin-bottom-8">
              Select employees to generate payslip.
            </p>
          }

          <div
            className="margin-top-16 thin-scroll"
            style={{ overflowY: "auto", height: "calc(80vh - 86px)" }}
          >
            {employeelist &&
              employeelist.map((emp, index) => (
                <div className={"details-list-expanded"}>
                  <div>
                    <div className="info-row">
                      <div
                        className="floatleft margin-right-8"
                        style={{ paddingTop: 3 }}
                      >
                        <div className={"padding-left-4"}>
                          {
                            <DynamicForm
                              fields={checkboxinputconverter({
                                value: emp.isexpanded,
                              })}
                              onChange={() => {
                                const temp = employeelist;
                                temp[index].isexpanded = !emp.isexpanded;
                                this.setState({
                                  employeelist: temp,
                                });
                              }}
                            />
                          }
                        </div>
                      </div>
                      <div className="floatleft">
                        <p className="small-blue t-bold">{emp.empfullname}</p>
                        <p className="small-dark-secondary">
                          {emp.designation}
                        </p>
                      </div>
                      <div className="clear-float"></div>
                    </div>
                  </div>
                </div>
              ))}
          </div>

          <div className="margin-top-16 margin-bottom-24">
            <Button
              className="btn btn-primary-md-blue"
              variant="contained"
              onClick={this.getPayslip}
            >
              Save
            </Button>
          </div>
        </Drawer>
      </Grid>
    );
  }
}

export default connect()(
  withStyles(styles, { withTheme: true })(withSnackbar(PayrollCompleted)),
);
